import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/react';

export interface ButtonProps {
  width?: number;
  height?: number;
  fontSize?: number;
  diameter?: number;
  styles?: SerializedStyles;
}

export const DefaultButtonCss = css`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;

  width: 326px;
  height: 48px;
  border-radius: 48px;
  font-size: 18px;
`;

const PrimaryButton = styled.button`
  ${DefaultButtonCss};
  border: unset;
  background: #00bf00;
  color: #fff;
  :hover {
    background: #7fe200;
  }
  :active {
    background: #00bf00;
  }
  :disabled {
    cursor: not-allowed;
    background-color: #999999;
    :hover {
      background: #999999;
    }
    :active {
      background: #999999;
    }
  }
  ${(props: ButtonProps) => props.styles};
`;

export default PrimaryButton;
